export default {
  name: 'whitePath',
  props: ['item', 'white_path', 'show', 'press', 'preview'],
  components: {},
  data: function () {
  return {
      path : undefined
    }
  },
  methods: {
    remove(c) { this.$emit('remove', c); },
    add(c) { this.$emit('add', c); this.path = ''; },
    clear(c) { this.$emit('clear'); },
  },
  created: function() {   console.log('whitePath.vue', 'created'); },
  destroyed: function() { console.log('whitePath.vue', 'destroyed'); },
  mounted: function() { console.log('whitePath.vue', 'mounted'); }

}